<div class="grid-container">
  <div class="grid-x">
    <div class="cell large-12 text-align-center bold border-bottom-medium-gray">
      eDiscovery Request {{requestId}}
    </div>
    @if (documentsLoaded) {
      <div class="cell large-6">
        Requested by: {{request.requestedByName}} on {{request.dateRequested | date: 'medium' }}
      </div>
      <div class="cell large-6">
        @if (request.status === statusType.RequestCompleted) {
          Completed on: {{request.dateCompleted | date: 'medium'}}
        }
        @if (request.status === statusType.RequestPending) {
          <strong>Request is pending completion</strong>
        }
      </div>
      <div class="cell large-12 text-align-center bold">
        Organization: {{organization.name}}
      </div>
      @if (request && request.status === statusType.RequestCompleted) {
        <div class="cell large-8">
          Combined document:
        </div>
        <div class="cell large-4 padding-left">
          @if (fullRequestDocument) {
            <button class="button" (click)="download(fullRequestDocument)">
              Download&nbsp;<svg-icon icon="icon-download" class="small white"></svg-icon>
            </button>
          }
        </div>
        <div class="cell large-3">
          Applications:
        </div>
        @if (applicationNumbers.length > 0) {
          <div class="cell large-5">
            <ul>
              @for (application of applicationNumbers; track application) {
                <li>
                  {{application}}
                </li>
              }
            </ul>
          </div>
          <div class="cell large-4 padding-left">
            @if (request.includeApplicationData) {
              Includes Application Data <br />
              Data: @if (appDataDocument) {
              <button class="button" (click)="download(appDataDocument)">
                Download&nbsp;<svg-icon icon="icon-download" class="small white"></svg-icon>
              </button>
              }<br />
            }
            @if (request.includeApplicationNotes) {
              Includes Application Notes <br />
              Notes: @if (appNotesDocument) {
              <button class="button" (click)="download(appNotesDocument)">
                Download&nbsp;<svg-icon icon="icon-download" class="small white"></svg-icon>
              </button>
            }
          }
        </div>
      } @else {
        <div class="cell large-9">
          Request does not include any applications
        </div>
      }
      <div class="cell large-3">
        Organization Notes:
      </div>
      @if (request.includeOrganizationNotes) {
        <div class="cell large-5">&nbsp;</div>
        <div class="cell large-4 padding-left">
          @if (organizationNotesDocument) {
            <button class="button" (click)="download(organizationNotesDocument)">
              Download&nbsp;<svg-icon icon="icon-download" class="small white"></svg-icon>
            </button>
          }
        </div>
      } @else {
        <div class="cell large-9">
          Request does not include organization notes
        </div>
      }
      <div class="cell large-3">
        Contact Notes:
      </div>
      @if (request.includeNotesForAllContacts || contacts.length > 0) {
        <div class="cell large-5">
          @if (request.includeNotesForAllContacts) {
            <strong>Includes Notes for all contacts as of the time of the request</strong>
          } @else {
            <ul>
              @for (contact of contacts; track contact) {
                <li>
                  {{contact}}
                </li>
              }
            </ul>
          }
        </div>
        <div class="cell large-4 padding-left">
          @if (contactNotesDocument) {
            <button class="button" (click)="download(contactNotesDocument)">
              Download&nbsp;<svg-icon icon="icon-download" class="small white"></svg-icon>
            </button>
          }
        </div>
      } @else {
        <div class="cell large-9">
          Request does not include contact notes
        </div>
      }
      <div class="cell large-3">
        Work Orders:
      </div>
      @if (request.includeAllWorkOrders || workOrders.length > 0) {
        <div class="cell large-5">
          @if (request.includeAllWorkOrders) {
            <strong>Includes All Work Orders as of the time of the request</strong>
          } @else {
            <ul>
              @for (order of workOrders; track order) {
                <li>
                  {{order}}
                </li>
              }
            </ul>
          }
        </div>
        <div class="cell large-4 padding-left">
          @if (workOrdersDocument) {
            <button class="button" (click)="download(workOrdersDocument)">
              Download&nbsp;<svg-icon icon="icon-download" class="small white"></svg-icon>
            </button>
          }
        </div>
      } @else {
        <div class="cell large-9">
          Request does not include any work orders
        </div>
      }
    }
    @if (request && request.status !== statusType.RequestCompleted) {
      <div class="cell large-3">
        Applications:
      </div>
      @if (applicationNumbers.length > 0) {
        <div class="cell large-5">
          <ul>
            @for (application of applicationNumbers; track application) {
              <li>
                {{application}}
              </li>
            }
          </ul>
        </div>
        <div class="cell large-4">
          @if (request.includeApplicationData) {
            Includes Application Data <br />
          } @else {
            Request does not include application data
          }
          @if (request.includeApplicationNotes) {
            Includes Application Notes
          } @else {
            Request does not include application notes
          }
        </div>
      } @else {
        <div class="cell large-9">
          Request does not include any applications
        </div>
      }
      <div class="cell large-3">
        Organization Notes:
      </div>
      @if (request.includeOrganizationNotes) {
        <div class="cell large-9">
          <strong>Request will include Organization Notes</strong>
        </div>
      } @else {
        <div class="cell large-9">
          Request does not include organization notes
        </div>
      }
      <div class="cell large-3">
        Contact Notes:
      </div>
      @if (request.includeNotesForAllContacts || contacts.length > 0) {
        <div class="cell large-9">
          @if (request.includeNotesForAllContacts) {
            <strong>Includes Notes for all contacts as of the time of the request</strong>
          } @else {
            <ul>
              @for (contact of contacts; track contact) {
                <li>
                  {{contact}}
                </li>
              }
            </ul>
          }
        </div>
      } @else {
        <div class="cell large-9">
          Request does not include contact notes
        </div>
      }
      <div class="cell large-3">
        Work Orders:
      </div>
      @if (request.includeAllWorkOrders || workOrders.length > 0) {
        <div class="cell large-9">
          @if (request.includeAllWorkOrders) {
            <strong>Includes All Work Orders as of the time of the request</strong>
          } @else {
            <ul>
              @for (order of workOrders; track order) {
                <li>
                  {{order}}
                </li>
              }
            </ul>
          }
        </div>
      } @else {
        <div class="cell large-9">
          Request does not include any work orders
        </div>
      }
    }
  } @else {
    Loading... please wait...
  }
</div>
</div>
<a #downloadLink href="" style="display: none;" target="_blank"></a>

